import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import FrameView from '@/views/frame/FrameView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    props: route => {
      return {
        token: route.query.token,
        exitUrl: route.query.exitUrl
      }
    },
    name: 'Login',
    component: () => import('@/views/frame/LoginView')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/overView')
  },
  {
    path: '/sys',
    component: FrameView,
    meta: {
      pathName: '系统管理'
    },
    children: [
      {
        path: 'companyMgr',
        name: 'companyMgr',
        component: () => import('@/views/company/companyMgr'),
        meta: {
          pathName: '专业公司'
        }
      },
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/banner/bannerMgr'),
        meta: {
          pathName: 'banner管理'
        }
      },
      {
        path: 'workTeamMgr',
        name: 'workTeamMgr',
        component: () => import('@/views/workTeam/workTeamMgr'),
        meta: {
          pathName: '劳务团队'
        }
      },
      {
        path: 'professionalMgr',
        name: 'professionalMgr',
        component: () => import('@/views/professional/professionalMgr'),
        meta: {
          pathName: '专家册'
        }
      },
      {
        path: 'record',
        name: 'record',
        component: () => import('@/views/record/record'),
        meta: {
          pathName: '留言板'
        }
      }
    ]
  },
  // 嵌入电缆外部访问地址开始
  {
    path: '/outDemo',
    component: FrameView,
    children: [
      {
        path: '',
        name: 'outDemo',
        component: () => import('@/views/frame/OutsideView'),
        meta: {
          pathName: 'outDemo'
        }
      }
    ]
  },
  // 嵌入电缆外部访问地址结束
  {
    path: '/404',
    component: FrameView,
    children: [
      {
        path: '',
        component: () => import('@/views/frame/NotFound')
      }
    ]
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  routes
})

// let fn = url => {
//   // [{ name: '', path: '' }] moduleUrl moduleName
//   let curModule = {}
//   let getModule = (list, url) => {
//     list.forEach(menu => {
//       if (menu.moduleUrl === url) {
//         curModule = menu
//       } else {
//         if (menu.children && menu.children.length > 0) {
//           getModule(menu.children, url)
//         }
//       }
//     })
//   }
//   getModule(store.state.allMenus, url)
//   let arr = []
//   let getPath = (list, moduleCode) => {
//     list.forEach(menu => {
//       if (menu.moduleCode === moduleCode) {
//         arr.push({
//           name: menu.moduleName,
//           path: menu.moduleUrl
//         })
//         getPath(list, menu.parentModule)
//       } else {
//         if (menu.children && menu.children.length > 0) {
//           getPath(menu.children, moduleCode)
//         }
//       }
//     })
//   }
//   getPath(store.state.allMenus, curModule.moduleCode)
//   console.log(arr)
// }

// const pathFn = path => {
//   let xs = store.state.allMenus.flatMap((x) => {
//     return x.children || []
//   })
//   xs = xs.flatMap((x) => {
//     return x.children || []
//   })
//   console.log(JSON.stringify(xs))
//   debugger
//   let menu = xs.find(x => x.moduleUrl === path)
//   let paths = [menu]
//   while (menu.parentModule !== '0') {
//     let parent = xs.find(x => {
//       if (x.moduleCode === menu.parentModule) {
//         return x
//       }
//     })
//     paths.unshift(parent)
//     menu = parent
//   }
//   return paths
// }

router.beforeEach((to, from, next) => {
  // console.log(pathFn(to.path))
  // let allMenus = store.state.allMenus
  store.commit('setPath', to.matched.map(route => route.meta.pathName))
  if (to.name !== 'Login' && to.matched.some(route => route.meta.requireAuth)) {
    if (store.state.token) {
      next()
    } else {
      next({ name: 'Login' })
    }
  } else {
    next()
  }
})

export default router
